import React, { createElement } from 'react';
import { Link } from 'react-router-dom';
import { HomeIcon, UserIcon, BriefcaseIcon, MailIcon, FileTextIcon, ShieldIcon, BookIcon } from 'lucide-react';
export function Sitemap() {
  const siteStructure = [{
    title: 'Home',
    path: '/',
    icon: HomeIcon,
    description: 'Main landing page with hero section and case study highlights'
  }, {
    title: 'About',
    path: '/about',
    icon: UserIcon,
    description: 'Professional background, experience, and personal details'
  }, {
    title: 'Portfolio',
    path: '/portfolio',
    icon: BriefcaseIcon,
    description: 'Complete collection of case studies and work examples',
    children: [{
      title: 'Product Turnaround Strategy',
      path: '/case-study-1',
      description: '$110M product platform turnaround'
    }, {
      title: 'Go-to-Market Strategy',
      path: '/case-study-2',
      description: 'GTM strategy with 93% conversion rate'
    }, {
      title: 'CRM Program Development',
      path: '/case-study-3',
      description: 'Neutrogena CRM program development'
    }, {
      title: 'AI-Driven FinTech Platform',
      path: '/case-study-5',
      description: 'AI-based interactive FinTech platform'
    }, {
      title: 'Product Innovation & Development',
      path: '/case-study-6',
      description: 'KOL-driven product innovation'
    }, {
      title: 'DTC Product Selection Quiz',
      path: '/case-study-9',
      description: 'DTC guided selling tool optimization'
    }]
  }, {
    title: 'Contact',
    path: '/contact',
    icon: MailIcon,
    description: 'Contact information and form'
  }, {
    title: 'Terms & Conditions',
    path: '/terms',
    icon: BookIcon,
    description: 'Legal terms and conditions for website usage'
  }, {
    title: 'Privacy Policy',
    path: '/privacy',
    icon: ShieldIcon,
    description: 'Information about how your data is collected and used'
  }];
  return <div className="container mx-auto px-4 py-12" data-id="element-148">
      <h1 className="text-3xl font-bold text-gray-900 mb-8 text-center" data-id="element-149">
        Site Map
      </h1>
      <div className="max-w-4xl mx-auto" data-id="element-150">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-151">
          {siteStructure.map(item => <div key={item.path} className="bg-white p-6 rounded-lg shadow-md" data-id="element-152">
              <div className="flex items-center mb-4" data-id="element-153">
                <div className="bg-[#E0F5F8] p-2 rounded-full mr-3" data-id="element-154">
                  {createElement(item.icon, {
                size: 20,
                className: 'text-[#0096B4]'
              })}
                </div>
                <Link to={item.path} className="text-xl font-semibold text-[#0096B4] hover:underline" data-id="element-155">
                  {item.title}
                </Link>
              </div>
              <p className="text-gray-600 mb-4" data-id="element-156">{item.description}</p>
              {item.children && <div className="mt-4 border-t border-gray-100 pt-4" data-id="element-157">
                  <h3 className="text-sm font-medium text-gray-500 mb-3" data-id="element-158">
                    Subpages:
                  </h3>
                  <ul className="space-y-2" data-id="element-159">
                    {item.children.map(child => <li key={child.path} className="pl-4 border-l-2 border-[#7DCCD8]" data-id="element-160">
                        <Link to={child.path} className="text-gray-700 hover:text-[#0096B4] font-medium" data-id="element-161">
                          {child.title}
                        </Link>
                        <p className="text-gray-500 text-sm" data-id="element-162">
                          {child.description}
                        </p>
                      </li>)}
                  </ul>
                </div>}
            </div>)}
        </div>
        <div className="bg-[#F0FAFC] p-6 rounded-lg" data-id="element-163">
          <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-164">
            Sitemap Hierarchy
          </h2>
          <div className="pl-4 border-l-2 border-[#0096B4]" data-id="element-165">
            <div className="mb-3" data-id="element-166">
              <Link to="/" className="text-[#0096B4] font-medium hover:underline" data-id="element-167">
                Home
              </Link>
            </div>
            <div className="mb-3" data-id="element-168">
              <Link to="/about" className="text-[#0096B4] font-medium hover:underline" data-id="element-169">
                About
              </Link>
            </div>
            <div className="mb-3" data-id="element-170">
              <Link to="/portfolio" className="text-[#0096B4] font-medium hover:underline" data-id="element-171">
                Portfolio
              </Link>
              <ul className="pl-6 mt-2 space-y-1" data-id="element-172">
                <li data-id="element-173">
                  <Link to="/case-study-1" className="text-gray-700 hover:text-[#0096B4]" data-id="element-174">
                    Product Turnaround Strategy
                  </Link>
                </li>
                <li data-id="element-175">
                  <Link to="/case-study-2" className="text-gray-700 hover:text-[#0096B4]" data-id="element-176">
                    Go-to-Market Strategy
                  </Link>
                </li>
                <li data-id="element-177">
                  <Link to="/case-study-3" className="text-gray-700 hover:text-[#0096B4]" data-id="element-178">
                    CRM Program Development
                  </Link>
                </li>
                <li data-id="element-179">
                  <Link to="/case-study-5" className="text-gray-700 hover:text-[#0096B4]" data-id="element-180">
                    AI-Driven FinTech Platform
                  </Link>
                </li>
                <li data-id="element-181">
                  <Link to="/case-study-6" className="text-gray-700 hover:text-[#0096B4]" data-id="element-182">
                    Product Innovation & Development
                  </Link>
                </li>
                <li data-id="element-183">
                  <Link to="/case-study-9" className="text-gray-700 hover:text-[#0096B4]" data-id="element-184">
                    DTC Product Selection Quiz
                  </Link>
                </li>
              </ul>
            </div>
            <div className="mb-3" data-id="element-185">
              <Link to="/contact" className="text-[#0096B4] font-medium hover:underline" data-id="element-186">
                Contact
              </Link>
            </div>
            <div className="mb-3" data-id="element-187">
              <Link to="/terms" className="text-[#0096B4] font-medium hover:underline" data-id="element-188">
                Terms & Conditions
              </Link>
            </div>
            <div className="mb-3" data-id="element-189">
              <Link to="/privacy" className="text-[#0096B4] font-medium hover:underline" data-id="element-190">
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>;
}